import { BulkBuyerSellersReducer, BulkBuyerSellersReducerStateWithListObject, BulkBuyerSellersReducerStateWithoutListObject, bulkBuyerSellersType } from "./types";

const OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE = {
    data: {},
    loading: false,
    error: null
};

const OBJECT_WITH_LIST_RESPONSE_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
};


const UploadBulkBuyerSellersFileReducer = (state: BulkBuyerSellersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBuyerSellersType.RESET_UPLOAD_BULK_BUYER_SELLERS_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const ListBulkBuyerSellersFileReducer = (state: BulkBuyerSellersReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE: {
            return {
                ...state,
                loading: true,
            };
        }
        case bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkBuyerSellersType.RESET_FETCH_BULK_BUYER_SELLERS_FILE: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const DownloadBulkBuyerSellersFileReducer = (state: BulkBuyerSellersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD: {
            return {
                loading: true,
            };
        }
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_DOWNLOAD: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const BulkBuyerSellersFileDetailReducer = (state: BulkBuyerSellersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL: {
            return {
                loading: true,
            };
        }
        case bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBuyerSellersType.RESET_FETCH_BULK_BUYER_SELLERS_FILE_DETAIL: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const BulkBuyerSellersFileVersionReducer = (state: BulkBuyerSellersReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION: {
            return {
                loading: true,
            };
        }
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_VERSION: {
            return {
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const PublishBulkBuyerSellersFileReducer = (state: BulkBuyerSellersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH: {
            return {
                loading: true,
            };
        }
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBuyerSellersType.RESET_BULK_BUYER_SELLERS_FILE_PUBLISH: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const ApproveBulkBuyerSellersFileReducer = (state: BulkBuyerSellersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBuyerSellersType.RESET_APPROVE_BULK_BUYER_SELLERS_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const RejectBulkBuyerSellersFileReducer = (state: BulkBuyerSellersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBuyerSellersType.RESET_REJECT_BULK_BUYER_SELLERS_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const ListBulkFileSpecificBuyerSellersReducer = (state: BulkBuyerSellersReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS: {
            return {
                ...state,
                loading: true,
            };
        }
        case bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkBuyerSellersType.RESET_FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};


const DeleteBulkBuyerSellersFileReducer = (state: BulkBuyerSellersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBuyerSellersReducer) => {
    switch (action.type) {
        case bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBuyerSellersType.RESET_DELETE_BULK_BUYER_SELLERS_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};


export {
    UploadBulkBuyerSellersFileReducer,
    ListBulkBuyerSellersFileReducer,
    DownloadBulkBuyerSellersFileReducer,
    BulkBuyerSellersFileDetailReducer,
    BulkBuyerSellersFileVersionReducer,
    PublishBulkBuyerSellersFileReducer,
    ApproveBulkBuyerSellersFileReducer,
    RejectBulkBuyerSellersFileReducer,
    ListBulkFileSpecificBuyerSellersReducer,
    DeleteBulkBuyerSellersFileReducer
}